// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nhtml[data-v-4b46b2fa] {\n  scroll-behavior: smooth;\n}\n.flex-card[data-v-4b46b2fa] {\n  display: flex;\n  justify-content: space-between;\n}\n.flex-align-center[data-v-4b46b2fa] {\n  align-items: center;\n}\n#userDropdownOpen[data-v-4b46b2fa]::after {\n  display: none !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
